import type { AppLocale} from '../../config';
import { locales, defaultLocale } from '../../config';

export function getLocaleFromPathname(pathname: string): AppLocale {
  const segments = pathname.split('/').filter(Boolean);
  const potentialLocale = segments[0] as AppLocale;
  return locales.includes(potentialLocale) ? potentialLocale : defaultLocale;
}
